mobileSize = 1000;

$(document).ready(function () {
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1000) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1001) {
    $('body').removeClass('saffireMobileSize');
  }

  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
  $('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);

  // Custom Nav Item
  const events = `${SITEBASEURL}events`;

  $('#mainNavigation .group').each(function () {
    const navItemURL = $(this).find('a').attr('href');
    const dropdown = $(this).find('.items');
    if (navItemURL === events) {
      dropdown.addClass('events');
    }
  });

  // Email Signup
  $('.homepage .emailSignup .emailSignupText').text('Sign up for event news.');
  $('.homepage .emailSignup .emailSubmitButton')
    .text('Subscribe')
    .attr('href', '/email.aspx')
    .attr('onclick', '');

  // Subpage Hero
  const heroHTML = '<div class="hero-wrapper" style="background-image: url()"></div>';

  let dynamicHero = () => {
    const image = $('.entityContainer .entityContainerRow.rowIndex-1').find('.imageModule-single img').attr('data-src');
    const title = $('.entityContainer .entityContainerRow.rowIndex-1').find('.dynamicPageTitle');
    // const imageSrc = image.replace(/(?=[() ])/g, '\\');
    console.log(image);

    $('.hero-wrapper').css('background-image', `url("${image}")`);
    $('.hero-wrapper').append(title);
  }

  if ($('body').hasClass('eclipse-subpage')) {
    $(heroHTML).prependTo('.wrapper');
    dynamicHero();
  }

  /// Countdown 2024

  if ($("body").hasClass("homepage")) {

    let eclipseDate = () => {

      const countDate = new Date('April 8, 2024').getTime();
      const now = new Date().getTime();
      const gap = countDate - now;

      // Time

      const second = 1000;
      const minute = second * 60;
      const hour = minute * 60;
      const day = hour * 24;

      // Calculate
      const textDay = Math.floor(gap / day);
      const textHour = Math.floor((gap % day / hour));
      const textMinute = Math.floor((gap % hour / minute));

      document.querySelector('.day').innerText = textDay;
      document.querySelector('.hour').innerText = textHour;
      document.querySelector('.minute').innerText = textMinute;

      /// Days Circle

      let dayImageNumber = textDay;

      if (textDay == 0) {
        dayImageNumber = 0;
      } else if (textDay < 75) {
        dayImageNumber = 1;
      } else if (textDay >= 75 && textDay <= 105) {
        dayImageNumber = 2;
      } else if (textDay < 165) {
        dayImageNumber = 3;
      } else if (textDay >= 165 && textDay <= 195) {
        dayImageNumber = 4;
      } else if (textDay <= 255) {
        dayImageNumber = 5;
      } else if (textDay >= 255 && textDay <= 285) {
        dayImageNumber = 6;
      } else if (textDay <= 364) {
        dayImageNumber = 7;
      } else if (textDay >= 365) {
        dayImageNumber = 8;
      }

      const dayImageUrl = `url("${FULLCLIENTTHEMEPATH}images/${dayImageNumber}.png")`;
      $('.container-day').css('background-image', dayImageUrl);

      /// Hours Circle
      let hourImageNumber = textHour;

      if (textHour == 0) {
        hourImageNumber = 0;
      } else if (textHour < 5) {
        hourImageNumber = 1;
      } else if (textHour >= 5 && textHour <= 7) {
        hourImageNumber = 2;
      } else if (textHour < 11) {
        hourImageNumber = 3;
      } else if (textHour >= 11 && textHour <= 13) {
        hourImageNumber = 4;
      } else if (textHour < 17) {
        hourImageNumber = 5;
      } else if (textHour >= 17 && textHour <= 19) {
        hourImageNumber = 6;
      } else if (textHour < 23) {
        hourImageNumber = 7;
      } else if (textHour >= 23) {
        hourImageNumber = 8;
      }

      const hourImageUrl = `url("${FULLCLIENTTHEMEPATH}images/${hourImageNumber}.png")`;
      $('.container-hour').css('background-image', hourImageUrl);

      /// Minutes Circle
      let minuteImageNumber = textMinute;

      if (textMinute == 0) {
        minuteImageNumber = 0;
      } else if (textMinute < 13) {
        minuteImageNumber = 1;
      } else if (textMinute >= 13 && textMinute <= 17) {
        minuteImageNumber = 2;
      } else if (textMinute < 28) {
        minuteImageNumber = 3;
      } else if (textMinute >= 28 && textMinute <= 32) {
        minuteImageNumber = 4;
      } else if (textMinute < 43) {
        minuteImageNumber = 5;
      } else if (textMinute >= 43 && textMinute <= 47) {
        minuteImageNumber = 6;
      } else if (textMinute < 58) {
        minuteImageNumber = 7;
      } else if (textMinute >= 58) {
        minuteImageNumber = 8;
      }

      const minuteImageUrl = `url("${FULLCLIENTTHEMEPATH}images/${minuteImageNumber}.png")`;
      $('.container-minute').css('background-image', minuteImageUrl);

    }

    // eclipseDate();

    // setInterval(eclipseDate, 1000);
  }
});

$(window).load(function () {
  $('body').addClass('pageIsLoaded');

  // Remove Footer Buttons
  if ($('body').hasClass('saffireMobileSize')) {
    $('.footerItems1 a').removeClass('button');
  }

  // Calendar Button
  $('.weekly-calendar').insertBefore('#calendarMobileToggle');

  // Weather Bug
  setInterval(function () {
    const str = $('#weatherBugDescription').text();
    const weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (!weatherBugSet && str != '') {
      $('#weatherBugWidget').addClass('weatherBugSet');
      const findSpace = str.lastIndexOf(' ');
      const stringLength = str.length;
      const res = str.substring(findSpace, stringLength);
      const start = str.substring(0, findSpace);
      $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
      $('#weatherBugWidget').css('visibility', 'visible');
    }
  }, 12);
});

$(window).resize(function () {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.footerItems1 a').removeClass('button');
  }
});